module.exports = __webpack_public_path__ + "assets/media/level-09.7636062b.png";